<template>
  <div class="pa-2">
    <div v-if="info === null">
      <v-card outlined class="pa-2" style="border-color: #f9a825">
        <v-row class="align-center">
          <v-col cols="2" class="text-center">
            <v-icon size="2rem" color="yellow darken-2">mdi-alert</v-icon>
          </v-col>
          <v-col cols="10" class="yellow--text text--darken-3 text-h6">
            查無病歷號:{{ patientId }}之患者，<br />或該患者未住院。
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div v-else>
      <v-row dense>
        <v-col cols="6">病人床號：{{ info.BedNo }}</v-col>
        <v-col cols="6">病人姓名：{{ info.NameMarked }}</v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-form
        v-model="valid.info"
        v-show="step === 0"
        class="row row--dense pt-1"
      >
        <v-col :cols="type === 'B' ? 6 : 12">
          <v-radio-group
            row
            :rules="[(v) => !!v || '請選擇探病或陪病']"
            v-model="type"
          >
            <v-radio
              v-for="(value, key) in types"
              :key="key"
              :label="value"
              :value="key"
              :disabled="key === 'A' && !isVisitable"
            />
          </v-radio-group>
        </v-col>

        <v-col cols="6" v-if="type === 'B'">
          <v-text-field
            v-model="temperature"
            :rules="[
              (v) => !!v || '請量測體溫後並輸入',
              (v) => (v >= 20 && v <= 48) || '體溫數值異常!',
            ]"
            label="體溫"
            hint="請量測體溫後並輸入"
            type="number"
            outlined
            persistent-hint
          ></v-text-field>
        </v-col>

        <v-col cols="12" v-if="type === 'A'">
          <div class="pb-2">
            ＊依據疾病管制局規範，112年12月1日起醫院探病原則調整：<br />
            每日二時段，每次二人。<br />
            上午 10:30-11:00、下午 17:00-17:30。<br />
            <span class="red--text">
              (小兒加護病房、新生兒中心：上午 10:30-11:00、下午 16:30-17:00)
            </span>
          </div>
        </v-col>

        <v-col v-if="!!type" cols="12">
          <v-card outlined class="pa-2" style="border-color: red">
            <div v-if="type == 'A'" class="grey--text text--darken-1">
              <div>有以下情形之探病時段及訪客人數不在此限：</div>
              <div>
                ●
                病人實施手術、侵入性檢查或治療等，須由家屬陪同或依法規須家屬親自簽署同意書或文件。
              </div>
              <div>
                ●
                收治於急診、加護病房、安寧病房等特殊單位，因應病人病情說明之需要。
              </div>
              <div>● 病人病情惡化或病危探視。</div>
              <div>● 其他特殊原因，經評估有必要探病且經醫療機構同意。</div>
            </div>
            <div v-else class="blue--text">
              <div>
                陪病人數以1人為限，但病人為兒童(12歲以下)、老人(65歲以上)、身心障礙或經醫療機構評估有照護需求者(如行動不便、生活無法自理等)，陪病人數上限為2人，
                <!-- <div>1. 陪病人數以1人為原則。</div>
                <div>2. 入院陪病當日進行抗原快篩(含家用快篩)。</div>
                <div>
                  3.
                  公費篩檢及免定期篩檢之條件為『完成疫苗追加劑接種』或『完成疫苗基礎劑接種14天
                  (含) 以上至3個月內』之陪病者。
                </div>
                <div>
                  4.
                  得免除篩檢條件：確定病例符合解除隔離條件且具發病日或採檢陽性日
                  (無症狀者適用) 15天 (含)以上至3個月內。
                </div> -->
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="type === 'A'">
          <v-card outlined>
            <v-row dense class="pa-2">
              <v-col cols="12" class="light-blue lighten-4 rounded">
                <span class="pl-1">探病者請勾選下列選項之一</span>
                <br />
                <span class="pl-1 red--text text-decoration-underline">
                  紅字情況應避免探病，如必要探病，應出具探視當日採檢之自費家用快篩陰性證明後探病。
                </span>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="visitCondition"
                  v-for="item in visitConditions"
                  :key="item.text"
                  :value="item.text"
                  :rules="[(v) => (!!v && v.length !== 0) || '請選擇選項之一']"
                  :color="item.alert ? 'red' : 'primary'"
                  class="mt-0"
                  hide-details
                >
                  <template #label>
                    <div :class="{ 'red--text': item.alert }">
                      {{ item.text }}
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="6" v-if="type !== null">
          <v-text-field
            v-model="name"
            :rules="[(v) => !!v || '請輸入姓名']"
            :label="`${types[type]}訪客姓名`"
            outlined
          />
        </v-col>
        <v-col cols="6" v-if="type !== null">
          <v-text-field
            v-model="phone"
            :rules="[
              (v) => !!v || '請輸入連絡電話',
              (v) => (v.length > 6 && v.length < 13) || '連絡電話號碼長度異常',
            ]"
            label="連絡電話"
            type="tel"
            outlined
            persistent-hint
          />
        </v-col>
        <v-col cols="6" v-if="type !== null">
          <v-menu transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                v-on="on"
                :label="`${types[type]}日期`"
                prepend-inner-icon="mdi-calendar"
                outlined
                readonly
                hide-details
                clearable
              />
            </template>
            <v-date-picker
              v-model="date"
              locale="zh-tw"
              :max="tomorrow"
              :min="today"
              no-title
              scrollable
            />
          </v-menu>
        </v-col>
        <v-col cols="6" v-if="type !== null">
          <v-menu
            transition="scale-transition"
            offset-y
            min-width="290px"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="time"
                v-on="on"
                :label="`${types[type]}時間`"
                prepend-inner-icon="mdi-clock"
                outlined
                readonly
                hide-details
              />
            </template>
            <v-time-picker
              v-model="time"
              locale="zh-tw"
              format="24hr"
              scrollable
            />
          </v-menu>
        </v-col>
        <v-col v-if="temperature >= 37.5" cols="12">
          <v-card
            width="65vw"
            outlined
            class="mx-auto pa-2 red--text"
            style="border-color: #f44336"
          >
            <v-row class="justify-center align-center">
              <v-col cols="2">
                <v-icon size="2rem" color="red">mdi-alert</v-icon>
              </v-col>
              <v-col cols="10" class="text-h6">
                <div>您的體溫過高！</div>
                <div>請間隔一段時間後再量測體溫。</div>
                <div>若是發燒，請至急診掛號！</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn
            color="primary"
            outlined
            :disabled="!valid.info"
            @click="goStepOne"
          >
            下一步
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-form>
      <div v-if="step === 1">
        <v-card
          flat
          height="70vh"
          class="overflow-x-hidden overflow-y-auto pt-2"
        >
          <v-form
            v-model="valid.question"
            ref="question"
            class="row row--dense pt-1"
          >
            <v-card outlined width="100%" class="mx-1">
              <v-row dense class="pa-2">
                <v-col cols="12" class="light-blue lighten-4 rounded">
                  <span class="pl-1">最近14日內是否有下列症狀</span>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="symptom"
                    v-for="item in symptoms"
                    :key="item"
                    :label="item"
                    :value="item"
                    :disabled="noSymptom == 'checked'"
                    :rules="[
                      (v) =>
                        v.length !== 0 ||
                        noSymptom === 'checked' ||
                        '請選擇上述症狀選項',
                    ]"
                    class="mt-0"
                    hide-details
                  />
                  <v-text-field
                    v-model="otherSymptom"
                    v-if="symptom.indexOf('其他') > -1"
                    :rules="[(v) => !!v || '請在此填寫其他症狀']"
                    label="請在此填寫其他症狀"
                    outlined
                    hide-details
                    class="pa-2"
                  />
                  <v-checkbox
                    v-model="noSymptom"
                    label="以上皆無"
                    value="checked"
                    class="mt-0"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined width="100%" class="mx-1 mt-2">
              <v-row dense class="pa-2">
                <v-col cols="12" class="light-blue lighten-4 rounded">
                  <span class="pl-1"> 最近7日內旅遊史？ </span>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="travelHistory"
                    :disabled="noTravelHistory"
                    label="曾至國外差旅(若有7天出國史，請延後探(陪)病)"
                    value="國外"
                    hide-details
                    class="mt-2"
                  />
                  <v-menu
                    v-if="travelHistory.indexOf('國外') > -1"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="returnDate"
                        v-on="on"
                        :rules="[(v) => !!v || '請選擇回國日期']"
                        label="回國日期"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        readonly
                        hide-details
                        clearable
                        class="px-8 pt-2"
                      />
                    </template>
                    <v-date-picker
                      v-model="returnDate"
                      locale="zh-tw"
                      no-title
                      scrollable
                    />
                  </v-menu>
                  <v-text-field
                    v-if="travelHistory.indexOf('國外') > -1"
                    v-model="aboardCountry"
                    :rules="[
                      (v) => !!v || '請輸入近期差旅之國家',
                      (v) =>
                        v.length <= 56 || '輸入之國家長度已大於最長國家名！',
                    ]"
                    class="px-8 pt-2"
                    label="前往差旅的國家"
                    prepend-inner-icon="mdi-earth"
                    outlined
                  />

                  <v-checkbox
                    v-model="travelHistory"
                    :disabled="noTravelHistory"
                    label="曾有國內差旅"
                    value="國內"
                    hide-details
                    class="mt-2"
                  />
                  <v-text-field
                    v-if="travelHistory.indexOf('國內') > -1"
                    v-model="county"
                    :rules="[
                      (v) => !!v || '請輸入近期差旅之縣市/地點',
                      (v) => v.length <= 20 || '輸入之縣市/地點長度過長！',
                    ]"
                    class="px-8 pt-2"
                    label="地點"
                    prepend-inner-icon="mdi-map-marker"
                    outlined
                    hide-details
                  />

                  <!-- <v-checkbox
                    label="陪病前14天居住在高風險縣市(台北、新北、基隆、桃園)"
                    v-model="travelHistory"
                    :disabled="noTravelHistory"
                    value="高風險"
                    class="mt-2"
                    hide-details
                  /> -->

                  <v-checkbox
                    label="無"
                    v-model="noTravelHistory"
                    class="mt-2"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined width="100%" class="mx-1 mt-2">
              <v-row dense class="pa-2">
                <v-col cols="12" class="light-blue lighten-4 rounded">
                  <span class="pl-1">您最進一個月內群聚史</span>
                </v-col>
                <v-col cols="12" class="pl-2">
                  <v-radio-group
                    v-model="isolationType"
                    row
                    label="同住家人最進一個月內曾經："
                    hide-details
                    class="mt-0 pt-0"
                    :disabled="noCrowdGather === 'checked'"
                  >
                    <v-radio
                      v-for="item in isolationTypes"
                      :key="item"
                      :label="item"
                      :value="item"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="12" v-if="isolationType !== null" class="px-4">
                  <v-menu
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="isolationDate"
                        v-on="on"
                        :rules="[(v) => !!v || '請輸入到期日']"
                        label="到期日"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        readonly
                        hide-details
                        clearable
                      />
                    </template>
                    <v-date-picker
                      v-model="isolationDate"
                      locale="zh-tw"
                      no-title
                      scrollable
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="crowdGather"
                    v-for="item in crowdGatherTypes"
                    :key="item"
                    :label="item"
                    :value="item"
                    class="mt-2"
                    hide-details
                    :disabled="noCrowdGather === 'checked'"
                  />

                  <v-checkbox
                    v-model="noCrowdGather"
                    label="無"
                    value="checked"
                    class="mt-0"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined width="100%" class="mx-1 mt-2">
              <v-row dense class="pa-2">
                <v-col cols="12" class="light-blue lighten-4 rounded">
                  <span class="pl-1">您的職業別為？</span>
                </v-col>
                <v-col cols="12">
                  <v-radio-group
                    v-model="job"
                    class="pt-2 mt-0"
                    hide-details
                    :rules="[(v) => !!v || '請選擇職業別']"
                  >
                    <v-radio
                      v-for="item in jobTypes"
                      :key="item"
                      :label="item"
                      :value="item"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined width="100%" class="mx-1 mt-2">
              <v-row dense class="pa-2">
                <v-col cols="12" class="light-blue lighten-4 rounded">
                  <span class="pl-1">聲明(Statement)</span>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    label="本人保證所填資料屬實，若有隱匿將接受傳染病防治法等法規之追訴究責，依此目的收集之資料，本院將依〔個人資料保護法〕，自收集日起28天後刪除。"
                    v-model="isAccepted"
                    :rules="[(v) => v || '']"
                    class="my-2"
                    hide-details
                  />
                  <v-divider />
                  <div class="yellow--text text--darken-3 py-2">
                    如果您勾選上述『STOCC』皆為『無』，之後若有任何改變，請您務必主動告知醫護人員，謝謝您對防疫的配合！
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </v-card>
        <v-row class="pt-1">
          <v-col cols="6" class="pb-0 mb-0">
            <v-btn width="100%" outlined color="grey" @click="backToStepZero">
              返回上一步
            </v-btn>
          </v-col>
          <v-col cols="6" class="pb-0 mb-0">
            <v-btn
              v-text="'送出'"
              color="success"
              width="100%"
              outlined
              :disabled="!valid.question"
              @click="send"
            />
          </v-col>
        </v-row>
      </div>
    </div>

    <v-dialog v-model="accomplish" persistent transition="dialog-transition">
      <v-card flat>
        <v-container>
          <v-row dense v-if="symptomOpt.length > 0" class="align-center">
            <v-col cols="2">
              <v-icon size="2rem" left color="yellow darken-2">
                mdi-alert-box-outline
              </v-icon>
            </v-col>
            <v-col cols="10" class="yellow--text text--darken-3 text-h6">
              因您有相關症狀，建議待症狀緩解後再{{
                types[type]
              }}，以降低病人感染風險。
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
          </v-row>
          <v-row dense v-if="isInPeriod" class="red--text align-center">
            <v-col cols="2">
              <v-icon size="2rem" left color="red">
                mdi-alert-octagram-outline
              </v-icon>
            </v-col>
            <v-col cols="10" class="text-h6">
              您在檢疫/自主管理期間，不符合探(陪)病原則。
            </v-col>
          </v-row>
          <v-row dense v-else class="blue--text align-center">
            <v-col cols="12" class="text-center text-h6"> </v-col>
            <v-col cols="2">
              <v-icon size="2rem" color="blue">mdi-check-bold</v-icon>
            </v-col>
            <v-col cols="10" class="text-h6">
              <div>{{ types[type] }}訪客：{{ name }}</div>
              <div>{{ types[type] }}日期：{{ date }}</div>
              <div>{{ types[type] }}時間：{{ time }}</div>
              <div v-if="type === 'B'">體溫：{{ temperature }}</div>
              <div>登錄完成，感謝您的配合。</div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-overlay absolute v-model="loading" class="text-center">
      <p>讀取中......</p>
      <v-progress-circular size="50" indeterminate />
    </v-overlay>
  </div>
</template>
<script>
import moment from "moment";
import api from "../utils/apis/AdMedicalApi";
export default {
  props: {
    patientId: Number,
  },
  data: () => ({
    loading: false,
    accomplish: false,
    step: 0,
    valid: {
      info: false,
      question: false,
    },
    info: { BedNo: null, Id: null, IsICU: false, Name: null, Unit: null },
    today: moment().format("yyyy-MM-DD"),
    tomorrow: moment().add(1, "days").format("yyyy-MM-DD"),
    timeNow: moment().format("HH:mm"),
    name: "",
    phone: "",
    type: null,
    types: { A: "探病", B: "陪病" },
    temperature: null,
    date: moment().format("yyyy-MM-DD"),
    time: "10:30",
    symptom: [],
    symptoms: [
      "發燒（≧38℃）（若有發燒，請掛急診）",
      "咳嗽",
      "喉嚨痛",
      "流鼻水",
      "味覺或嗅覺異常",
      "腹瀉",
      "呼吸急促",
      "倦怠",
      "其他",
    ],
    noSymptom: null,
    otherSymptom: null,
    noTravelHistory: false,
    travelHistory: [],
    returnDate: null,
    aboardCountry: "",
    county: "",
    isolationType: null,
    isolationTypes: ["居家隔離", "居家檢疫", "自主健康管理"],
    isolationDate: null,
    crowdGather: [],
    crowdGatherTypes: [
      "同住家人最近14日內有發燒或呼吸道症狀、味(嗅)覺異常、腹瀉或倦怠",
      "同一辦公室同事或同班同學等常規接觸對象，最近14日內有1人以上有發燒或呼吸道症狀、味(嗅)覺異常、腹瀉或倦怠",
    ],
    noCrowdGather: null,
    job: null,
    jobTypes: [
      "醫療照護工作人員(含醫療院所和照護機構工作人員)",
      "旅遊業(如導遊)",
      "交通運輸業(如計程車、客運司機等)",
      "旅館業(如房務、客務接待人員)",
      "航空服務業工作(如航空機組人員等)",
      "其他",
      "無",
    ],
    isAccepted: null,
    visitableUnits: ["ICU", "10A2", "RCC", "6Q", "8A", "8B"],
    visitConditions: [
      { text: "無COVID-19相關症狀且無暴露風險者。", alert: false },
      { text: "有COVID-19相關症狀者。", alert: true },
      { text: "自主防疫期間。", alert: true },
      { text: "自主健康管理期間。", alert: true },
    ],
    visitCondition: null,
  }),

  computed: {
    symptomOpt() {
      if (this.symptom.indexOf("其他") !== -1) {
        var symptom = [...this.symptom];
        symptom.splice(symptom.indexOf("其他"), 1);
        return [...symptom, this.otherSymptom];
      } else return this.symptom;
    },
    travelHistoryOpt() {
      let arr = [];
      if (this.travelHistory.indexOf("國外") > -1)
        arr.push(`國外 ${this.aboardCountry} 回國日 ${this.returnDate}`);
      if (this.travelHistory.indexOf("國內") > -1)
        arr.push(`國內 ${this.county}`);
      if (this.travelHistory.indexOf("高風險") > -1)
        arr.push(`陪病前14天居住在高風險縣市(台北、新北、基隆、桃園)`);
      return arr;
    },
    isInPeriod() {
      let res = false;
      if (this.travelHistory.indexOf("國外") > -1 && this.returnDate !== null) {
        res = moment(this.today).diff(this.returnDate, "day") < 22;
      }
      return res;
    },
    crowdGatherHistory() {
      if (this.isolationType != null)
        return [
          ...this.crowdGather,
          `${this.isolationType} 到期日 ${this.isolationDate}`,
        ];
      else return this.crowdGather;
    },
    isVisitable() {
      // 112/12/01 取消每日探病人數上限限制
      // return (
      //   this.visitableUnits.indexOf(this.info.Unit) > -1 ||
      //   this.info.IsICU ||
      //   this.info.IsVisitable
      // );
      // return (
      //   this.visitableUnits.indexOf(this.info.Unit) > -1 || this.info.IsICU
      // );
      return true;
    },
  },

  watch: {
    type(val) {
      if (val === "A") {
        // this.time = this.info.IsICU ? "10:30" : "10:00";
        this.time = "10:30";
        this.temperature = null;
        if (parseInt(moment().format("HHmm")) > 1100) this.date = this.tomorrow;
      } else {
        this.date = this.today;
        this.timeNow = moment().format("HH:mm");
        this.time = moment().format("HH:mm");
      }
    },
    symptom(val) {
      if (val.length === 0) this.otherSymptom = "";
    },
    noSymptom(val) {
      if (val !== null) this.symptom = [];
    },
    noTravelHistory(val) {
      if (val) this.travelHistory = [];
    },
    noCrowdGather(val) {
      if (val !== null) {
        this.isolationType = null;
        this.isolationDate = null;
        this.crowdGather = [];
      }
    },
  },

  methods: {
    backToStepZero() {
      this.step = 0;
      this.symptom = [];
      this.noSymptom = null;
      this.otherSymptom = null;
      this.noTravelHistory = false;
      this.travelHistory = [];
      this.returnDate = null;
      this.aboardCountry = "";
      this.county = "";
      this.isolationType = null;
      this.isolationDate = null;
      this.crowdGather = [];
      this.noCrowdGather = null;
      this.job = null;
    },
    goStepOne() {
      // 112/12/01 取消每日探病人數上限限制
      // if (this.type === "A") {
      //   api
      //     .IsVisitable({
      //       Id: this.info.Id,
      //       VisitDate: this.date,
      //     })
      //     .then((res) => {
      //       if (res.data) this.step = 1;
      //       else
      //         alert(
      //           `欲探病之病患已達每日探病人數上限(${this.date})，請改日再訪，或改以視訊方式探病。`
      //         );
      //     });
      // } else this.step = 1;
      this.step = 1;
    },
    send() {
      if (!this.$refs.question.validate()) {
        alert("尚有欄位未填寫!");
        return;
      }
      if (!this.noTravelHistory && this.travelHistoryOpt.length === 0) {
        alert("請填寫旅遊史欄位!");
        return;
      }
      if (this.noCrowdGather === null && this.crowdGatherHistory.length === 0) {
        alert("請填寫群聚史欄位!");
        return;
      }
      api.SetPatientVisitorLog({
        Type: this.type,
        Date: moment().format("yyyy-MM-DD"),
        Unit: this.info.Unit,
        BedNo: this.info.BedNo,
        PatientId: this.info.Id,
        PatientName: this.info.NameMarked,
        Name: this.name,
        Phone: this.phone,
        Temperature: this.temperature,
        VisitCondition: this.visitCondition,
        VisitDate: this.date,
        VisitTime: this.time,
        TravelHistory: this.travelHistoryOpt,
        Job: this.job,
        Symptoms: this.symptomOpt,
        CrowdGather: this.crowdGatherHistory,
        IsInPeriod: this.isInPeriod,
      });
      this.accomplish = true;
    },
  },

  async mounted() {
    this.loading = true;
    try {
      var res = await api.PatientInfo({ id: this.patientId });
      this.info = res.data;
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  },
};
</script>
